import { createContext } from 'react';
import { User } from 'models/User';
import { ProfileFormValues } from '../../components/ProfileFormWrapper/ProfileFormWrapper.component';
import { CallbackConfig } from 'providers/CurrentUser/CurrentUser.context';
import { DropzoneFile } from 'components/Dropzone/utils';
import utils from 'utils';

type CurrentProfileContextProps = {
  isMyProfile: boolean;
  currentProfile: User | null;
  profileFormValues: Partial<ProfileFormValues>;
  patchCurrentProfile: (
    user: Partial<User>,
    config?: CallbackConfig,
  ) => Promise<void>;
  updateProfilePicture: (image: DropzoneFile | null) => void;
  updateFirmLogo: (image: DropzoneFile | null) => void;
};

export default createContext<CurrentProfileContextProps>({
  isMyProfile: false,
  currentProfile: null,
  profileFormValues: null,
  patchCurrentProfile: utils.noop,
  updateProfilePicture: utils.noop,
  updateFirmLogo: utils.noop,
});
